import { useEffect, useState } from 'react';
import { BrowserRouter } from 'react-router-dom';

import API from 'services/API';
import RoutesList from './Routes';
import { subscribe } from 'utils/Event';
import { LoadingProvider, NavProvider } from 'utils/context';
import Maintenance from 'components/pages/Maintenance';
import * as queries from '../graphql/queries';
import * as subscriptionsAws from '../graphql/subscriptions';

import { generateClient } from 'aws-amplify/api';

const client = generateClient();

const Router = () => {
  const [maintenance, setMaintenance] = useState(false);

  // When user reload or reach the application
  client
    .graphql({
      query: queries.getMaintenance,
      variables: { id: process.env.REACT_APP_APPSYNC_MAINTENANCE_ID },
    })
    .then(({ data }) => setMaintenance(data.getMaintenance.maintenance)),
    (error) => {
      console.error(error);
    };

  // When user is already using the application
  client.graphql({ query: subscriptionsAws.onUpdateMaintenance }).subscribe({
    next: (data) => {
      setMaintenance(data?.onUpdateMaintenance?.maintenance);
    },
    error: (error) => {
      console.error(error);
    },
  });
  useEffect(() => {
    let controller = new AbortController();

    // Interceptors axios to allow some cancel http request
    API.interceptors.request.use((config) => {
      subscribe('cancelHttpRequest', () => {
        controller.abort();
        controller = new AbortController();
      });
      return {
        ...config,
        signal: controller.signal,
      };
    });
  }, []);

  return (
    <>
      {maintenance ? (
        <Maintenance />
      ) : (
        <BrowserRouter>
          <NavProvider>
            <LoadingProvider>
              <RoutesList />
            </LoadingProvider>
          </NavProvider>
        </BrowserRouter>
      )}
    </>
  );
};

export default Router;
